import AllocationForm from "./AllocationForm";

export default AllocationForm;